/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CopropertyEligibilityDto } from './CopropertyEligibilityDto';
import {
    CopropertyEligibilityDtoFromJSON,
    CopropertyEligibilityDtoFromJSONTyped,
    CopropertyEligibilityDtoToJSON,
    CopropertyEligibilityDtoToJSONTyped,
} from './CopropertyEligibilityDto';

/**
 * 
 * @export
 * @interface UpdateCopropertyResponse
 */
export interface UpdateCopropertyResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCopropertyResponse
     */
    isSuccess?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateCopropertyResponse
     */
    errorCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCopropertyResponse
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCopropertyResponse
     */
    id?: string | null;
    /**
     * Verdict of the saved sub-step, computed in the same round trip. Absent when isSuccess is false.
     * @type {CopropertyEligibilityDto}
     * @memberof UpdateCopropertyResponse
     */
    eligibility?: CopropertyEligibilityDto | null;
}

/**
 * Check if a given object implements the UpdateCopropertyResponse interface.
 */
export function instanceOfUpdateCopropertyResponse(value: object): value is UpdateCopropertyResponse {
    return true;
}

export function UpdateCopropertyResponseFromJSON(json: any): UpdateCopropertyResponse {
    return UpdateCopropertyResponseFromJSONTyped(json, false);
}

export function UpdateCopropertyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCopropertyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'] == null ? undefined : json['isSuccess'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'id': json['id'] == null ? undefined : json['id'],
        'eligibility': json['eligibility'] == null ? undefined : CopropertyEligibilityDtoFromJSON(json['eligibility']),
    };
}

export function UpdateCopropertyResponseToJSON(json: any): UpdateCopropertyResponse {
    return UpdateCopropertyResponseToJSONTyped(json, false);
}

export function UpdateCopropertyResponseToJSONTyped(value?: UpdateCopropertyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'errorCode': value['errorCode'],
        'errorMessage': value['errorMessage'],
        'id': value['id'],
        'eligibility': CopropertyEligibilityDtoToJSON(value['eligibility']),
    };
}

